<template>
  <div class="answer" :class="answerTheme">
    <div class="label"><span class="title">{{answerTitle}}</span><div v-if="answerWords" class="words"> {{answerWords}}</div></div>
        <div class="control">

<!--          <div class="tabs is-boxed">-->
<!--            <ul>-->
<!--              <li class = "tab generateFromText" data-type="generateFromText" :class="(answerGenerationType === 'generateFromText' || !answerGenerationType) ? 'is-active' : ''">-->
<!--                <a v-on:click="activateTab('generateFromText')">-->
<!--                  <span>Сгенерировать из текста</span>-->
<!--                </a>-->
<!--              </li>-->
<!--              <li  class = "tab uploadFile" data-type="uploadFile" :class="answerGenerationType === 'uploadFile' ? 'is-active' : ''">-->
<!--                <a v-on:click="activateTab('uploadFile')">-->
<!--                  <span>Загрузить файл</span>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <div class="tabs-content">-->
<!--            <div class="tab-content generateFromText main" :class="(answerGenerationType === 'generateFromText' || !answerGenerationType)  ? 'is-active' : ''" >-->
              <div class="control">
  <!--              <textarea v-model="answerText" class="textarea"></textarea>-->
                <textarea :value="answerText" @input="$emit('update:answerText', $event.target.value)" class="textarea"></textarea>
                <div class="control is-grouped generate_audio_control">
                  <button class="button add_parameter"  v-on:click="addParameter()">{{$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')}} <span>{}</span></button>


                  <button class="button is-primary generate_button" v-on:click="genAudio()">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.onLoading"></div>
                    {{$t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio')}}
                  </button>

                  <div class="select is-primary speaker">
                    <select :value="answerSpeaker" @input="$emit('update:answerSpeaker', $event.target.value)" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select :value="answerEmotion" @input="$emit('update:answerEmotion', $event.target.value)" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p class="speed">
                    <slider size="small" v-bind:value="parseFloat(answerSpeed)" :min="0.5" :step="0.1" :max="2" @change="$emit('update:answerSpeed', $event)"></slider>
                    {{$t('scenarios.konstruktor.canvas.answer.initAudio.speed')}}:&nbsp{{answerSpeed}}
                  </p>
                </div>
                <div class="audio_list" v-if="answerAudio && Array.isArray(answerAudio)" >
                  <div v-for="audio of answerAudio" class="audio" :class="audio.type">
                    <audio v-if="audio.type==='url' && audio.url" :ref="'onPlayer'">
                      <source v-bind:src="audio.url">
                      {{$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')}}
                    </audio>
                    <audio-player v-if="audio.type==='url' && audio.url " :file="audio.url" :onLoad="onLoadAudio"/>
                    <div v-if="audio.type==='url' && audio.url" v-on:click="deleteAudio(audio)" class="deleteAudio" title="Удалить аудио"><i class="fas fa-backspace fa-3x"></i></div>
                  </div>
                </div>
                <div v-else-if="answerAudio && typeof answerAudio === 'string' || answerAudio instanceof String" class="audio_single">
                  <audio :ref="'onPlayer'">
                    <source v-bind:src="answerAudio">
                    {{$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')}}
                  </audio>
                  <audio-player :file="answerAudio" :onLoad="onLoadAudio"/>
                </div>
              </div>
            </div>

<!--            <div class="tab-content uploadFile main" :class="answerGenerationType === 'uploadFile' ? 'is-active' : ''" >-->
<!--              <div class="control">-->
<!--                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile()">-->
<!--                <input class="loadAudio" style="display:none;" @input="loadAudio(this)" name="load-audio" type="file" accept=".wav,.mp3">-->
<!--                <div class="audio_single" v-if="answerAudio">-->
<!--                  <audio :ref="'onPlayer'">-->
<!--                    <source v-bind:src="answerAudio">-->
<!--                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.-->
<!--                  </audio>-->
<!--                  <audio-player :file="answerAudio" :onLoad="onLoadAudio"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

  </div>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../components/audio-player.vue'
  import { mapGetters } from 'vuex'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import Modal from './ModalAudio'
  import Slider from 'vue-bulma-slider'
  import BaseComponent from './BaseComponent'


  const audioGeneratorApi = {
     'yandex': '/audios/generate',
     'google': '/tts/google/generate'
  }
  const audioUploadApi = '/audios/reSave'
  const audioDeleteApi = '/audios'

  export default {
    extends: BaseComponent,
    props: ['answerTitle', 'answerText', 'answerAudioId', 'answerAudio', 'answerWords', 'answerTheme', 'answerVendor', 'answerSpeaker', 'answerEmotion', 'answerSpeed', 'scenarioId', 'client', 'isSaved', 'answerLocale', 'answerGenerationType'],
    components: {
      Modal,
      Cleave,
      AudioPlayer,
      Collapse,
      CollapseItem,
      Slider
    },
    computed: {
      ...mapGetters([
        'loadedScenario',
        'loggedId',
        'loggedUser',
        'authenticationToken'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      addParameter() {
        this.$emit('update:answerText', (this._props.answerText || '') + '{parameterName}')
      },
      genAudioRequest(text) {
        let vendor = this._props.answerVendor || 'yandex'
        if (vendor === 'yandex') {
          return this.genAudioRequestByYandex(text)
        } else if (vendor === 'google') {
          return this.genAudioRequestByGoogle(text)
        }
        return request
      },
      genAudioRequestByYandex(text) {
          let request = {
              'client': this._props.client,
              'scenario': this._props.scenarioId,
              'audioName': this._props.name,
              'generator': this._props.answerVendor || 'yandex',
              'text': text,
              'parameters': {
                  'speaker': this._props.answerSpeaker,
                  'emotion': this._props.answerEmotion,
                  'speed': this._props.answerSpeed,
                  'text': text
              }
          }
          // if audio already generated, request must contain id, so backend will overwrite existing audio
          if (this._props.id) {
              request.id = this._props.id
          }
          return request
      },
      genAudioRequestByGoogle(text) {
            let request = {
                'languageCode': this._props.answerLocale,
                'voiceName': this._props.answerSpeaker,
                'text': text,
                'speakingRate': this._props.answerSpeed,
                'client': this._props.client,
                'scenario': this._props.scenarioId,
                'audioName': this._props.name
            }

            // if audio already generated, request must contain id, so backend will overwrite existing audio
            if (this._props.id) {
                request.id = this._props.id
            }
            return request
       },
       securityHeaders() {
        return {
          'testH': 'testHV',
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
        }
      },
      getAudioGeneratorUrl() {
          let vendor = this._props.answerVendor || 'yandex'
          return audioGeneratorApi[vendor]
      },
      onLoadAudio(data) {
        this.$emit('setAudioDuration', data)
      },
      genAudio() {
        let texts = this.parseText()
        let index = 0

        let that = this

        function requestSuccessCallback(data, number) {
          if (that.tmp.onLoading) {
            that.$emit('generateAudioHandler', {
              number: number,
              type: 'url',
              url: `/audios/${data}.wav`,
              // url: `https://akvapark.app.ivoice.online/audios/a79818c0-adcb-11e9-9604-6b9f04b1d17d.wav`,
              theme: that._props.answerTheme
            })
            index++
            if (index === texts.length) {
              that.tmp.onLoading = false
            }
          }
        }
        function requestFailCallback(error) {
          that.tmp.onLoading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
        }

        if (!this._props.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          // this.tmp.onLoading = true
          this.$emit('generateAudioHandler', {theme:this._props.answerTheme})
          const headers = {headers: this.securityHeaders()}

          for (let i = 0; i < texts.length; i++) {
            if (texts[i].type === 'text') {
              const request = this.genAudioRequest(texts[i].text)
              this.tmp.onLoading = true
              this.$http.post(this.getAudioGeneratorUrl(), request, headers)
                .then(response => {
                  requestSuccessCallback(response.data, i)
                })
                .catch(error => {
                  requestFailCallback(error)
                  // if (error || requestFailCallback) {
                  //   requestSuccessCallback('111' + i, i)
                  // }
                })
            } else {
              this.$emit('generateAudioHandler', {number:i, type:'param', paramName:texts[i].paramName, theme:this._props.answerTheme})
              index++
            }
          }
        }
      },
      parseText() {
        let fullText = (this._props.answerText || '') + ''
        let texts = []
        let symbol = '{'
        let finder = 'open_param'

        while (fullText.length) {
          let startParam = fullText.indexOf(symbol)
          if (startParam > -1) {
            let text = fullText.substr(0, startParam)
            if (text) {
              if (finder === 'open_param') {
                texts.push({
                  type: 'text',
                  text: text.replace('{', '').replace('}', '')
                })
              } else {
                texts.push({
                  type: 'param',
                  paramName: text.replace('{', '').replace('}', '')
                })
              }
            }
            finder = finder === 'open_param' ? 'close_param' : 'open_param'
            symbol = symbol === '{' ? '}' : '{'
            fullText = fullText.substr(startParam + 1)
          } else {
            if (fullText) {
              texts.push({
                type: 'text',
                text: fullText
              })
            }
            fullText = ''
          }
        }
        return texts
      },
      getAudioId(audio) {
        let url = audio.url
        return url.substring(
          url.lastIndexOf('/audios/') + 8,
          url.lastIndexOf('.wav')
        )
      },
      deleteAudio(audio) {
        let that = this
        this.$http.delete(`${audioDeleteApi}/${this.getAudioId(audio)}`, {headers: this.prepareUploadHeaders()})
          // .then((response) => {
          //
          // })
          // .catch((error) => {
          //   console.log(error)
          //   // this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          //   audio.theme = that._props.answerTheme
          //   that.$emit('deleteAudioHandler', audio)
          // })
        audio.theme = that._props.answerTheme
        that.$emit('deleteAudioHandler', audio)
      },
      // uploadFile() {
      //   if (!this.isSaved) {
      //     this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
      //   } else {
      //     document.querySelector('.' + this._props.answerTheme + ' .loadAudio').click()
      //   }
      // },
      loadAudio() {
        let input = document.querySelector('.' + this._props.answerTheme + ' .loadAudio')
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequest(input.files[0])
            // this.$refs[player].load()
          }
        }
      },
      handleUploadRequest (audioFile) {
        let that = this
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders())
          .then(response => {
            that.$emit('generateAudioHandler', {
              type: 'url',
              url: `/audios/${response.data}.wav`,
              theme: that._props.answerTheme
            })
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      prepareMultipartAudio (audioFile) {
        const audioFormData = new FormData()
        audioFormData.append('file', audioFile)
        audioFormData.append('name', this._props.answerTheme + '_name')
        audioFormData.append('id', this._props.answerAudioId)
        audioFormData.append('client', this._props.client)
        audioFormData.append('scenario', this._props.scenarioId)
        return audioFormData
      },
      // activateTab (tabClass) {
      //   this.$emit('changeGenerationType', tabClass)
      // },
      prepareUploadHeaders () {
        return {
          'headers': {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
            'Content-Type': 'multipart/form-data',
            'testH': 'testHV'
          }
        }
      }
    },
    data() {
      return {
        tmp: {
          onLoadedAudio: '',
          onLoading: false,
          currentSpeaker: 'oksana',
          currentEmotion: 'neutral',
          currentSpeed: 1
        },
        speakerList: [
          {
            value: 'jane'
          },
          {
            value: 'oksana'
          },
          {
            value: 'alyss '
          },
          {
            value: 'omazh'
          },
          {
            value: 'zahar '
          },
          {
            value: 'ermil '
          }
        ],
        currentEmotion: 'neutral',
        emotionList: [
          {
            value: 'good'
          },
          {
            value: 'neutral'
          },
          {
            value: 'evil'
          }
        ]
      }
    }

  }

</script>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/mixins';

  .spinner {
    margin-right: 5px;
  }

  .custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
  }
  .custom-file-input::before {
    content: 'Select some files';
    display: inline-block;
    background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }
  .custom-file-input:hover::before {
    border-color: black;
  }
  .custom-file-input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
  p {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }

  .answer .label {
    white-space: nowrap;
  }

  .answer .label .title {
    font-size: 16px;
  }
  .answer .label .words {
    font-size: 10px;
  }

  .answer .label .words {
    white-space: nowrap;
    overflow-x: hidden;
    display: inline;
    font-weight: normal;
  }

  .add_parameter {
    margin-right: 32px;
  }

  .add_parameter span {
    margin-left:5px;
  }

  .audio_list .audio {
    margin-top:5px;
  }
  .audio_list .audio.param {
    display: none;
  }

  .deleteAudio {
    /*width: 15%;*/
    /*max-width: 52px;*/
    display: inline;
    float:right;
    /*margin-right: -4px;*/
  }
  .deleteAudio i {
    color:indianred;
    font-size: 2.4em;
    cursor: pointer;
    margin-top: -2px;
  }
  .deleteAudio i:hover {
    color:red;
    font-size: 2.5em;
    margin-top: -3px;
  }

  .tabs-content .tab-content {
    display:none;
  }

  .tabs-content .tab-content.is-active {
    display:block;
  }
  .tab-content.inputUrls {
    max-height: 137px;
    overflow-y: scroll;
  }

  .tabs a {
    padding-bottom: 0;
  }
</style>

<style>
  .active_scenario_akvamir .add_parameter {
    display: none;
  }
</style>




// WEBPACK FOOTER //
// Answer.vue?23160e97